<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import CustomIcon from '@/_company/components/CustomIcon.vue';

const props = defineProps({
  cell: {
    type: Object,
    default: () => {},
  },
  row: {
    type: Object,
    default: () => {},
  },
});

const emit = defineEmits(['onClick']);

const { t } = useI18n();

const isDisabledAction = computed(() => {
  const isRevoked = props.row.cells.find((c) => c.status === 'revoked');
  return isRevoked && props.cell.id !== 'view';
});
</script>

<template>
  <button
    :id="`${cell.id}-button`"
    class="icon-button black"
    :class="cell.id"
    @click="emit('onClick', cell.action, cell.value)"
    v-if="!isDisabledAction"
  >
    <CustomIcon :icon="cell.icon" :width="24" :svg="true" />
    <span class="label">{{ t(`company.certificates.${cell.id}`) }}</span>
  </button>
</template>

<style lang="scss" scoped>
@include icon-button;

.icon-button {
  display: flex;
  align-items: center;
  gap: $space-8;

  &.revoke:hover {
    color: $negative-foreground;
    fill: $negative-foreground;
  }
}

.label {
  @include button-label-small;
  white-space: nowrap;

  @include desktop-small {
    display: none;
  }
}
</style>
